export default __webpack_public_path__ + "images/ok.73ad23e4.svg";